import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  useNavigate,
  useLocation,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Title } from 'react-admin';
import { LAYOUT } from '../../../theme';
import { GenresSettings } from '../components/GenresSettings';
import { TagsSettings } from '../../settings/pages/TagsSettings';
import { DynamicsSettings } from '../components/DynamicsSettings';
import { PersonasSettings } from '../components/PersonasSettings';
import { VoiceProfilesSettings } from '../components/VoiceProfilesSettings';
import { NarrativeFormsSettings } from '../components/NarrativeFormsSettings';

export const BuildingBlocks: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine current tab based on URL
  const getTabValue = () => {
    if (location.pathname.includes('/genres')) {
      return 0;
    } else if (location.pathname.includes('/tags')) {
      return 1;
    } else if (location.pathname.includes('/dynamics')) {
      return 2;
    } else if (location.pathname.includes('/personas')) {
      return 3;
    } else if (location.pathname.includes('/voices')) {
      return 4;
    } else if (location.pathname.includes('/forms')) {
      return 5;
    }
    return 0; // Default to genres
  };

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/building-blocks/genres');
        break;
      case 1:
        navigate('/building-blocks/tags');
        break;
      case 2:
        navigate('/building-blocks/dynamics');
        break;
      case 3:
        navigate('/building-blocks/personas');
        break;
      case 4:
        navigate('/building-blocks/voices');
        break;
      case 5:
        navigate('/building-blocks/forms');
        break;
      default:
        navigate('/building-blocks/genres');
        break;
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: LAYOUT.mediumContentWidth,
          margin: '0 auto',
        }}
      >
        <Title title="Building Blocks" />

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={getTabValue()} onChange={handleTabChange}>
            <Tab label="Genres" />
            <Tab label="Tags" />
            <Tab label="Dynamics" />
            <Tab label="Personas" />
            <Tab label="Voices" />
            <Tab label="Narrative Forms" />
          </Tabs>
        </Box>

        <Routes>
          <Route path="genres" element={<GenresSettings />} />
          <Route path="tags" element={<TagsSettings />} />
          <Route path="dynamics" element={<DynamicsSettings />} />
          <Route path="personas" element={<PersonasSettings />} />
          <Route path="voices" element={<VoiceProfilesSettings />} />
          <Route path="forms" element={<NarrativeFormsSettings />} />
          <Route
            path="/"
            element={<Navigate to="/building-blocks/genres" replace />}
          />
        </Routes>
      </Box>
    </Box>
  );
};
